/**
 * Salva o token no localStorage
 * @param {string} token - Token de autenticação
 */
export const saveToken = (token) => {
  localStorage.setItem('token', token);
};

/**
 * Remove o token do localStorage
 */
export const removeToken = () => {
  localStorage.removeItem('token');
};

/**
 * Obtém o token do localStorage
 * @returns {string|null} Token armazenado
 */
export const getToken = () => {
  return localStorage.getItem('token');
};

/**
 * Salva o ID do cliente no localStorage
 * @param {number|string} clienteId - ID do cliente
 */
export const saveClienteId = (clienteId) => {
  localStorage.setItem('clienteId', String(clienteId));
};

/**
 * Remove o ID do cliente do localStorage
 */
export const removeClienteId = () => {
  localStorage.removeItem('clienteId');
};

/**
 * Obtém o ID do cliente do localStorage
 * @returns {number|null} ID do cliente armazenado
 */
export const getClienteId = () => {
  const id = localStorage.getItem('clienteId');
  return id ? parseInt(id, 10) : null;
};

function generateSessionId() {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

/**
 * Identificador deste dispositivo/navegador para a trava de sessão da sala.
 * Fica no localStorage para o mesmo aparelho recuperar a própria vaga ao reabrir o discador.
 * @returns {string}
 */

const DIALER_SESSION_ID_KEY = 'discadorSessionId';

export const getDialerSessionId = () => {
  let sessionId = localStorage.getItem(DIALER_SESSION_ID_KEY);
  if (!sessionId) {
    sessionId = generateSessionId();
    localStorage.setItem(DIALER_SESSION_ID_KEY, sessionId);
  }
  return sessionId;
};
